export const TRANSACTION_HISTORY = "TRANSACTION_HISTORY"

export const TRANSACTION_HISTORY_REQUEST = "TRANSACTION_HISTORY_REQUEST"
export const TRANSACTION_HISTORY_SUCCESS = "TRANSACTION_HISTORY_SUCCESS"
export const TRANSACTION_HISTORY_FAILURE = "TRANSACTION_HISTORY_FAILURE"